import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import "./style.css";

const TabDetails = props => {
  const { changeCurrentTab, currentTab } = props;
  // BEGIN REDUX STATE
  const notesCount = useSelector(state =>
    state.detailsDocument.info.details
      ? state.detailsDocument.info.details.notes.length
      : 0);
  // END REDUX STATE

  return (
    <div className="tabContainer">
      <div
        className={"itemContainer " + (currentTab === 1 ? "active" : "")}
        id="dettaglio"
        onClick={() => changeCurrentTab(1)}
      >
        <div>
          <FormattedMessage id="documents.detail.tab1" />
        </div>
      </div>
      <div
        className={
          "itemContainer gs-documents-detail-tab-note " +
          (currentTab === 2 ? "active" : "")
        }
        id="note"
        onClick={() => changeCurrentTab(2)}
      >
        <div>
          <span style={{ verticalAlign: "middle" }}>
            <FormattedMessage id="documents.detail.tab2" />{" "}
          </span>{" "}
          {notesCount > 0 ? (
            <div className="badgeNote">
              {notesCount > 100 ? "99+" : notesCount}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TabDetails;
